export const DATE_FORMAT = {
  FULL: 'MM/DD/YYYY HH:mm',
};
